<img class="img-responsive img_cls" [src]="band_preview"
name="image">